import { createPortal } from "react-dom";
import "../styles/HistoryModel.css";

//  Icons 
const PrintIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 6 2 18 2 18 9" />
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);
const CheckCircleIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const LockIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const UserIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const CloudUpIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="16 16 12 12 8 16" />
    <line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);
const UploadIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);
// Default history events 
const DEFAULT_HISTORY = [
  { id: 1, label: "Report Printed",         timestamp: "2026-04-08 09:21:21", ago: "23h", icon: <PrintIcon />,       side: "right" },
  { id: 2, label: "Report Printed",         timestamp: "2026-04-08 09:21:21", ago: "23h", icon: <PrintIcon />,       side: "left"  },
  { id: 3, label: "Report Signed Off",      timestamp: "2026-04-07 18:25:00", ago: "2d",  icon: <CheckCircleIcon />, side: "right" },
  { id: 4, label: "Report Locked",          timestamp: "2026-04-07 18:04:01", ago: "2d",  icon: <LockIcon />,        side: "left"  },
  { id: 5, label: "Report Assigned",        timestamp: "2026-04-07 17:40:05", ago: "2d",  icon: <UserIcon />,        side: "right" },
  { id: 6, label: "Study Upload Completed", timestamp: "2026-04-07 17:26:14", ago: "2d",  icon: <CloudUpIcon />,     side: "left"  },
  { id: 7, label: "Study Upload Started",   timestamp: "2026-04-07 17:25:44", ago: "2d",  icon: <UploadIcon />,      side: "right" },
];
//  Main HistoryModal 
export default function HistoryModal({ patient, onClose, onOpenDashboard, onOpenStudy }) {
  const history = patient?.history || DEFAULT_HISTORY;
  return createPortal(
    <div className="hm-overlay" onClick={onClose}>
      <div className="hm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="hm-header">
          <span className="hm-patient-name">
            {patient?.patient}
          </span>
        </div>
        {/* Timeline */}
        <div className="hm-body">
          {history.map((event, idx) => {
            const isLeft = event.side === "left";
            return (
              <div key={event.id || idx} className="hm-timeline-row">
                <div className="hm-left-col">
                  {isLeft ? (
                    <div className="hm-event-box">
                      <span className="hm-event-label">{event.label}</span>
                    </div>
                  ) : (
                    <span className="hm-timestamp">
                      {event.timestamp} ({event.ago})
                    </span>
                  )}
                </div>
                <div className="hm-center-col">
                  <div className="hm-icon-circle">{event.icon}</div>
                  {idx < history.length - 1 && <div className="hm-connector" />}
                </div>
                <div className="hm-right-col">
                  {!isLeft ? (
                    <div className="hm-event-box">
                      <span className="hm-event-label">{event.label}</span>
                    </div>
                  ) : (
                    <span className="hm-timestamp">
                      {event.timestamp} ({event.ago})
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {/* Footer */}
        <div className="hm-footer">
          <button className="hm-btn-dashboard" onClick={onOpenDashboard}>
            OPEN DASHBOARD
          </button>
          <button className="hm-btn-study" onClick={onOpenStudy}>
            OPEN STUDY
          </button>
          <button className="hm-btn-close" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}